import React, { PropsWithChildren } from 'react';
import styles from './index.module.scss';


export default function ProPlanPill({
    className = '',
  }: PropsWithChildren<{ className?: string }>) {
    return <span className={`${styles['pill']} ${className ? className : ''}`}>{'PRO PLAN'}</span>;
  }